import React, { useState, useEffect } from "react";
import Input from '../../../components/ui/Input';
import { Checkbox } from "../../../components/ui/Checkbox";

const BookingDetails = ({ bookingData, onDataUpdate }) => {
  // Check if any selected service is a post-natal service
  const hasPostNatalService = bookingData?.services?.some(
    service => service?.category === 'post-natal'
  );

  const [formData, setFormData] = useState({
    name: bookingData?.details?.name || "",
    email: bookingData?.details?.email || "",
    phone: bookingData?.details?.phone || "",
    gender: bookingData?.details?.gender || (hasPostNatalService ? "Female" : ""),
    notes: bookingData?.details?.notes || "",
    reminderPreferences: bookingData?.details?.reminderPreferences || [],
  });

  // Auto-select Female gender when post-natal service is selected
  useEffect(() => {
    if (hasPostNatalService && formData.gender !== "Female") {
      const updatedData = { ...formData, gender: "Female" };
      setFormData(updatedData);
      onDataUpdate({ details: updatedData });
    }
  }, [hasPostNatalService]);

  const handleChange = (field, value) => {
    const updatedData = { ...formData, [field]: value };
    setFormData(updatedData);
    onDataUpdate({ details: updatedData });
  };

  const handleReminderToggle = (method) => {
    const updated = formData?.reminderPreferences?.includes(method)
      ? formData?.reminderPreferences?.filter((m) => m !== method)
      : [...formData?.reminderPreferences, method];
    handleChange("reminderPreferences", updated);
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">
        Your Details
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Full Name"
          placeholder="Enter your full name"
          value={formData?.name}
          onChange={(e) => handleChange("name", e?.target?.value)}
          required
        />

        <Input
          label="Email (Optional)"
          type="email"
          placeholder="your.email@example.com"
          value={formData?.email}
          onChange={(e) => handleChange("email", e?.target?.value)}
        />

        <Input
          label="Phone Number"
          type="tel"
          placeholder="+1 (555) 000-0000"
          value={formData?.phone}
          onChange={(e) => handleChange("phone", e?.target?.value)}
          required
        />

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Gender
            {hasPostNatalService && (
              <span className="ml-2 text-xs text-purple-600 font-normal">
                (Auto-selected for post-natal services)
              </span>
            )}
          </label>
          <select
            value={formData?.gender}
            onChange={(e) => handleChange("gender", e?.target?.value)}
            className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent ${hasPostNatalService ? 'bg-gray-100 cursor-not-allowed' : ''
              }`}
            required
            disabled={hasPostNatalService}
          >
            <option value="">Select Gender</option>
            {!hasPostNatalService && <option value="Male">Male</option>}
            <option value="Female">Female</option>
            {/* <option value="Other">Other</option>
            <option value="Prefer not to say">Prefer not to say</option> */}
          </select>
          {hasPostNatalService && (
            <p className="mt-1 text-xs text-gray-500">
              Post-natal services are only available for female clients
            </p>
          )}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Additional Notes (Optional)
        </label>
        <textarea
          value={formData?.notes}
          onChange={(e) => handleChange("notes", e?.target?.value)}
          rows={4}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          placeholder="Any special requests or preferences..."
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">
          Reminder Preferences
        </label>
        <div className="space-y-2">
          <Checkbox
            label="Email Reminder"
            checked={formData?.reminderPreferences?.includes("email")}
            onChange={() => handleReminderToggle("email")}
          />
          <Checkbox
            label="SMS Reminder"
            checked={formData?.reminderPreferences?.includes("sms")}
            onChange={() => handleReminderToggle("sms")}
          />
          <Checkbox
            label="WhatsApp Reminder"
            checked={formData?.reminderPreferences?.includes("whatsapp")}
            onChange={() => handleReminderToggle("whatsapp")}
          />
        </div>
      </div>
    </div>
  );
};

export default BookingDetails;